import { Breadcrumbs } from '~/components/breadcrumbs';
import { Program } from '~/features/program/models/program';
import { ProgramMetadata } from '~/features/program/models/program-metadata';
import { toSchoolSlug } from '~/features/school/utils/to-school-slug';
import { useCatalogPath } from '~/hooks/use-catalog-path';
import { useI18n } from '~/hooks/use-i18n';

export type ProgramBreadcrumbsProps = {
  schoolSlug?: string;
  schoolName?: string;
  programTitle: string;
};

export function ProgramBreadcrumbs({ schoolSlug, schoolName, programTitle }: ProgramBreadcrumbsProps) {
  const { t } = useI18n();
  const catalogPath = useCatalogPath();

  const items = [
    { label: t('program.allPrograms'), href: catalogPath },
    ...(schoolSlug && schoolName ? [{ label: schoolName, href: `/school/${schoolSlug}` }] : []),
    { label: programTitle },
  ];

  return <Breadcrumbs items={items} />;
}

export function transformStaticProgramBreadcrumbsProps({
  programMetadata,
  program,
}: {
  programMetadata: ProgramMetadata;
  program: Program;
}) {
  const primarySchool = programMetadata.rootProgram?.schools?.find((school) => school.isPrimary);
  const schoolName = primarySchool ? primarySchool.name : programMetadata.rootProgram?.schools?.[0]?.name || '';
  const schoolSlug = toSchoolSlug(schoolName);

  return {
    schoolSlug,
    schoolName,
    programTitle: program.title,
  };
}

export type StaticProgramBreadcrumbsProps = ReturnType<typeof transformStaticProgramBreadcrumbsProps>;
